import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';

export const SeeHistoryButton = ({ onClick, isActive }: { onClick: () => void; isActive?: boolean }) => {
  const { t } = useTranslation('phone');

  return (
    <Button variant='secondary' iconName='clock-small' onClick={onClick}>
      {isActive ? t('Hide History') : t('See History')}
    </Button>
  );
};
